// style.ts
import styled from 'styled-components';

interface StyledBasicSearchProps {
  noinput?: string;
}

export const StyledBasicSearch = styled.div<StyledBasicSearchProps>`
  position: relative;
  width: 300px;

  .MuiInputBase-root {
    padding-right: 8px;
  }

  .MuiTextField-root {
    margin: 0;
    width: 100%;
    background-color: ${({ noinput }) => (noinput === 'noinput' ? '#80808017' : '#fff')};
    border-radius: 6px;

    input {
      padding: 10px 0 10px 12px;
      font-size: 14px;
      font-weight: 400;
      color: #585959;
      line-height: 18px;
    }
  }

  .MuiOutlinedInput-input {
    width: 100%;
    border-radius: 6px;
    outline: none;
    appearance: none;
    background-color: #fff;
  }

  button {
    margin: 0 4px;
  }
`;
